/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import styled from 'styled-components';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIToggle from 'UIComponents/input/UIToggle';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { OLAF } from 'HubStyleTokens/colors';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { UserAttributeKeys, useUserAttribute } from '../../userAttributes';
import { useShowWizardLanguageToggle } from '../wizardQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LanguageToggleLabel = styled(UIFormLabel).withConfig({
  displayName: "WizardLanguageToggle__LanguageToggleLabel",
  componentId: "gvoz5h-0"
})(["color:", ";line-height:18px;@media (max-width:", "){flex:1;padding-top:4px !important;}"], OLAF, GRID_BREAKPOINT_SMALL);
const LanguageToggleTipHeader = styled(FormattedMessage).withConfig({
  displayName: "WizardLanguageToggle__LanguageToggleTipHeader",
  componentId: "gvoz5h-1"
})(["font-size:16px;margin-bottom:4px;display:block;"]);
export const WizardLanguageToggle = ({
  showMoreContentInEnglishTooltip
}) => {
  const {
    userAttribute: includeEnglish,
    setUserAttribute: setPreappliedFilter,
    unsetUserAttribute: unsetPreappliedFilter,
    userAttributeLoading
  } = useUserAttribute(UserAttributeKeys.PREAPPLIED_FILTER_CHANGED);
  const {
    languageName,
    show
  } = useShowWizardLanguageToggle();
  const onToggleLanguageFilter = useCallback(() => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-toggle-include-english',
      completedState: !includeEnglish
    });
    if (!includeEnglish) {
      setPreappliedFilter(true);
    } else {
      unsetPreappliedFilter();
    }
  }, [includeEnglish, setPreappliedFilter, unsetPreappliedFilter]);
  useEffect(() => {
    if (show) {
      UsageTracker.track('wizardInteraction', {
        action: 'wizard-toggle-viewed'
      });
    }
  }, [show]);
  if (!show || userAttributeLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UITooltip, {
      open: showMoreContentInEnglishTooltip,
      placement: "bottom",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LanguageToggleTipHeader, {
          message: "learningCenter.wizard.progresspanel.languageToggleLabelTipHeader"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.wizard.progresspanel.languageToggleLabelTipContent",
          options: {
            languageName
          }
        })]
      }),
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        children: [/*#__PURE__*/_jsx(LanguageToggleLabel, {
          htmlFor: "languageToggle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.wizard.progresspanel.languageToggleLabel"
          })
        }), /*#__PURE__*/_jsx(UIToggle, {
          checked: !!includeEnglish,
          "data-test-id": "wizard-language-toggle",
          id: "languageToggle",
          onChange: onToggleLanguageFilter,
          size: "small"
        })]
      })
    })
  });
};